export default {
    methods: {
        percentageDifference(num1, num2) {
            // Return 0% diff if both same
            if (num2 === num1) {
                return 0;
            }

            // If one if zero they are 100% diff - don't allow division by zero
            if (num2 === 0 || num1 === 0) {
                return 100;
            }

            // Absolute difference as inverse percentage
            return Math.abs((1 - (num2 / num1)) * 100);
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/percentageDifference.js